export default "__VITE_ASSET__CBOmV9ed__"